var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMobileOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 152,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#333"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2.632,
  d: "M75.998 41.505a6.58 6.58 0 0 0-6.58-6.58H35.224a6.58 6.58 0 0 0-6.58 6.58v69.568a6.58 6.58 0 0 0 6.58 6.58h34.195a6.583 6.583 0 0 0 6.579-6.58z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeWidth: 1.316,
  d: "M46.406 43.8h8.46m2.307 0h.768"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.316,
  d: "M52.33 110.507a5.767 5.767 0 1 0 0-11.534 5.767 5.767 0 0 0 0 11.534Z"
}))));
export default SvgIconMobileOutline;